<template>
    <div>
        <el-dialog class="invoice" :title="title" :visible.sync="dialogVisible" width="60%"
            :close-on-click-modal="false">
            <div class="buttons">
                <el-button type="primary" v-has="'07060009'" @click="banlancePrint" :disabled="totalData.length===0">余额明细导出</el-button>
            </div>
            <div class="tables-content">
                <el-table :data="totalData" style="width: 100%;margin-bottom: 10px;" v-loading="isDialogLoading">
                    <el-table-column prop="endAccountPeriod" label="截止会计期间">
                    </el-table-column>
                    <el-table-column prop="ledgerName" show-overflow-tooltip label="会计主体">
                    </el-table-column>
                    <el-table-column prop="suppliersName" show-overflow-tooltip label="供应商">
                    </el-table-column>
                    <el-table-column prop="companyName" show-overflow-tooltip label="分公司">
                    </el-table-column>
                    <el-table-column prop="siteName" show-overflow-tooltip label="服务平台">
                    </el-table-column>
                    <el-table-column prop="invoiceNo" show-overflow-tooltip label="发票号">
                    </el-table-column>
                    <el-table-column prop="invoiceAmt" show-overflow-tooltip label="发票金额">
                    </el-table-column>
                    <el-table-column prop="invoiceBalance" show-overflow-tooltip label="发票余额">
                    </el-table-column>
                    <el-table-column prop="paymentType" show-overflow-tooltip label="款项类别">
                    </el-table-column>
                </el-table>
                <m-page ref="page" :current-page="currentPage" :pageData="config.page" :total="pageTotal"
                    @on-page-change="pageChange" @on-size-change="sizeChange"></m-page>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import mPage from '@/components/supplierPanel/mPage';
export default {
    components: { mPage },
    props: {
        config: Object,
        totalData: Array,
        pageTotal: Number,
        currentPage: Number,
        title: {
            type: String
        }
    },
    data() {
        return {
            isDialogLoading: false,
            dialogVisible: false
        };
    },
    methods: {
        // 分页器改变触发事件
        pageChange(page) {
            this.$emit('pageChange', page);
        },
        sizeChange(size) {
            this.config.page.pageSize = size;
            this.$emit('sizeChange', size);
        },
        banlancePrint(data) {
            this.$emit('bsExport', data);
        }
    },
    mounted() {

    }
};
</script>

<style lang="less">
.tables-content {
    padding-bottom: 30px;
    margin-top: 16px;
}
</style>
